
import { defineComponent } from 'vue';
import { PaymentProviderBankDetails } from '@/interfaces/bank-account';
import { selectedPaymentOption } from '@/interfaces/payment-options';

export default defineComponent({
  name: 'PaymentOptionSelect',

  data() {
    const selectedPaymentOpt: selectedPaymentOption | null = {
      id: '',
      type: '',
      text: '',
      lastFour: '',
      paymentProviderDetails: '',
    };
    return {
      selectedPaymentOpt: selectedPaymentOpt as selectedPaymentOption | null,
    };
  },

  computed: {
    bankAccount(): PaymentProviderBankDetails {
      return this.$store.getters['PaymentOptions/getBankAccount'];
    },

    card() {
      return this.$store.getters['PaymentOptions/getCard'];
    },

    paymentMethods() {
      const options = [];

      if (this.bankAccount && this.$store.getters['PaymentOptions/bankAccountIsVerified']) {
        options.push({
          id: this.bankAccount.id,
          type: 'bank',
          text: `Bank account ending in ${this.bankAccount.bank_account_last_4}`,
          lastFour: this.bankAccount.bank_account_last_4,
          paymentProviderDetails: this.bankAccount.payment_provider_details_id,
        });
      }

      if (this.card) {
        options.push({
          id: this.card.id,
          type: 'card',
          text: `Debit card ending in ${this.card.card_last_4}`,
          lastFour: this.card.card_last_4,
          paymentProviderDetails: this.card.payment_provider_details_id,
        });
      }

      return options;
    },
  },

  watch: {
    paymentMethods: {
      handler() {
        if (this.paymentMethods.length) {
          this.selectedPaymentOpt = this.paymentMethods[0];
        } else {
          this.selectedPaymentOpt = null;
        }

        this.$emit('input', this.selectedPaymentOpt);
      },
    },

    selectedPaymentOpt: {
      handler(val: selectedPaymentOption | null) {
        this.$emit('input', val);
      }
    }
  },

  mounted() {
    this.selectedPaymentOpt = this.paymentMethods[0];
    this.$emit('input', this.selectedPaymentOpt);
  },
});
